import { ComponentProps, CSSProperties, HTMLAttributes, ReactElement, SyntheticEvent } from 'react';
import { components } from 'react-select';

import { IOption } from '~/ui/components/inputs/Select/types';

type MultiValueRemoveProps = ComponentProps<typeof components.MultiValueRemove>;

const MultiValueRemove = (props: MultiValueRemoveProps): ReactElement => {
  const { data, selectProps } = props;
  const disableOption = selectProps.isOptionDisabled as ((option: IOption) => boolean) | undefined;
  const removeDisabled = Boolean(disableOption?.(data as IOption));

  if (!removeDisabled) {
    return <components.MultiValueRemove {...props} />;
  }

  /** innerProps merges RS `removeProps` (onClick → removeValue) — must override onClick too */
  const base = props.innerProps as HTMLAttributes<HTMLDivElement>;

  const disabledClickHandler = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <span role="presentation" style={{ display: 'inline-flex', alignItems: 'center' }}>
      <components.MultiValueRemove
        {...props}
        innerProps={
          {
            ...base,
            onMouseDown: disabledClickHandler,
            onTouchEnd: disabledClickHandler,
            onClick: disabledClickHandler,
            style: {
              ...(base.style as CSSProperties | undefined),
              opacity: 0.38,
              cursor: 'auto',
            },
          } as MultiValueRemoveProps['innerProps']
        }
      />
    </span>
  );
};

export default MultiValueRemove;
